<template>
  <div class="manufacturers">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="manufacturers">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.manufacturers') | firstLetterCapitalize }}
          </div>
          <div class="label-desc">Manufacturers management</div>
        </div>
        <ManufacturerList />
      </el-tab-pane>
      <el-tab-pane name="subscription ">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Subscription
          </div>
          <div class="label-desc">Subscription management</div>
        </div>
        <SubscriptionList />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ManufacturerList from '@/components/products/manufacturers/ManufacturerList'
import SubscriptionList from '@/components/products/manufacturers/SubscriptionList'
export default {
  data() {
    return {
      activeName: 'manufacturers',
      screenWidth: window.innerWidth
    }
  },
  components: {
    ManufacturerList,
    SubscriptionList
  },
  mounted: function() {
    window.addEventListener('resize', this.getScreenWidth)
    this.getScreenWidth()
  },
  methods: {
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  }
}
</script>
